import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import Flex from "components/common/Flex";
import Lottie from "lottie-react";
import animationData from "./lottie/warning-light.json";

const CustomWizardModal = ({ modal, setModal, title, description }) => {
  console.log({ description });

  const lines =
    typeof description === "string" ? description.split("<br />") : description;

  return (
    <Modal
      show={modal}
      onHide={() => setModal(false)}
      centered
      size={Array.isArray(description) && "lg"}
    >
      <Modal.Header className="border-1 border-bottom pb-0">
        <h5 className="modal-title fs-9 fw-semibold">{title}</h5>
        <FalconCloseButton
          size="sm"
          className="position-absolute top-0 end-0 me-2 mt-2"
          onClick={() => setModal(false)}
        />
      </Modal.Header>
      <Modal.Body className="pt-0">
        <Flex justifyContent="center" alignItems="center" direction="column">
          <Lottie
            animationData={animationData}
            loop={true}
            style={{ width: "100px", marginBottom: "1rem" }}
          />
          {(() => {
            const lines =
              typeof description === "string"
                ? description.split("<br />")
                : description;

            return Array.isArray(lines) ? (
              <ul className="fs-10 list-unstyled text-start mb-2 ps-3">
                {lines.map((msg, index) => {
                  const isLast = index === lines.length - 1;
                  return (
                    <li key={index} className="mb-2">
                      {isLast ? msg : `${index + 1} - ${msg}`}
                    </li>
                  );
                })}
              </ul>
            ) : (
              <p className="fs-10 text-center mb-0">{description}</p>
            );
          })()}
        </Flex>
      </Modal.Body>
    </Modal>
  );
};

CustomWizardModal.propTypes = {
  modal: PropTypes.bool.isRequired,
  setModal: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

CustomWizardModal.defaultProps = {
  title: "Error",
  description: "An error occurred. Please try again.",
};

export default CustomWizardModal;
